export default "__VITE_ASSET__9f35d5d2__"